import { render, staticRenderFns } from "./menu_item.vue?vue&type=template&id=5324a6ea&scoped=true&"
import script from "./menu_item.vue?vue&type=script&lang=js&"
export * from "./menu_item.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5324a6ea",
  null
  
)

export default component.exports